class GoUpData {

    constructor() {

        this._defaultRightScreenSeparation = 15;
        this._defaultScrollToShowButton = 250;
        this._defaultTimeToDissapearButton = 1000;
        this._defaultFadeInOutAnimationTime = 500;
        this._visibleButton = false;
        this._inactiveScroll = null;

    }

    getDefaultSeparation() {
        return this._defaultRightScreenSeparation;
    }

    getDefaultScrollHeight() {
        return this._defaultScrollToShowButton
    }

    getDefaultTimeToDissapear() {
        return this._defaultTimeToDissapearButton;
    }

    getDefaultAnimationTime() {
        return this._defaultFadeInOutAnimationTime;
    }

    getIsVisible() {
        return this._visibleButton;
    }

    getInactiveScroll() {
        return this._inactiveScroll;
    }

    setVisible(isVisible) {
        this._visibleButton = isVisible;
    }

    setInactiveScroll(inactiveScroll) {
        this._inactiveScroll = inactiveScroll;
    }

}